export enum ProjectStructureType {
  Module = 'module',
  Application = 'application',
  Template = 'template'
}
